<template>
  <div class="baseIntroduce">
    <div class="baseIntroduce-frame">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '' }">活动</el-breadcrumb-item>
        <el-breadcrumb-item class="special-active">
          {{activeNav}}
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="baseIntroduce-main">
        <img class="type-img" v-if=" matchFileSuffixType(IntroduceData.multipartIntroduce) === 'image'"
        :src="IntroduceData.multipartIntroduce"/>

        <video v-if=" matchFileSuffixType(IntroduceData.multipartIntroduce) === 'video'"
          :src='IntroduceData.multipartIntroduce'
          class="type-video"
          controls='controls'
          muted
          autoplay>
        </video>

        <div>
          <p class="title" v-if="activeNav === '海创大赛'">中国海归创业大赛</p>
          <p class="title" v-if="activeNav === '企业评选'">最具成长性创业企业评选</p>
          <p class="title" v-if="activeNav === '网络年会'">全国留学人员创业园网络年会</p>

          <p class="main">{{ IntroduceData.literalIntroduce }}</p>

          <div class="activeBtn"
            @click="goSomePage('/HCMegagameGetAwardProject')"
            v-if="activeNav === '海创大赛'">
            <img style="cursor: pointer;" src="@/assets/active/activeBtn1.png" alt="" />
          </div>

          <div class="firmElectBtn" v-if="activeNav === '企业评选'">
            <span class="btn" @click="goSomePage('/firmBeSelected')">
              <img style="cursor: pointer;" src="@/assets/active/activeBtn2.png" alt=""/>
            </span>
            <span class="btn" @click="goSomePage('/firmDevelopmentReport')">
              <img style="cursor: pointer;" src="@/assets/active/activeBtn3.png" alt=""/>
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinFun from '@/utils/mixin'
export default {
  name: 'baseIntroduce',
  mixins: [mixinFun],
  props: {
    activeNav: String,
    IntroduceData: Object
  },
  components: {},
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {
    // 页面跳转
    goSomePage (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="less">
.baseIntroduce {
  width: 1200px;
  height: 330px;
  border-radius: 2px;
  background-color: #fff;
  margin: 20px auto 5px;
}
.baseIntroduce-frame {
  box-sizing: border-box;
  padding: 20px;
  /deep/.el-breadcrumb__inner {
    font-size: 16px;
    color: #000;
  }
  /deep/.is-link {
    font-size: 16px;
    font-weight: 500;
    color: #999 !important;
  }

  .baseIntroduce-main {
    position: relative;
    display: flex;
    margin: 22px 0 0 0;
    box-sizing: border-box;
    .type-img,
    .type-video {
      min-width: 379px ;
      max-width: 379px ;
      height: 239px;
      border-radius: 10px;
      margin-right: 34px;
      border-radius: 10px;
    }
    .title {
      font-size: 20px;
      font-weight: 600;
    }
    .main {
      font-size: 16px;
      color: #898b91;
      font-family: "Microsoft YaHei";
      line-height: 1.5;
      margin: 16px 0 20px;
    }
    .activeBtn {
      position: absolute;
      bottom: 0;
      width: 207px;
      height: 71px;
      img {
        width: 207px;
        height: 71px;
      }
    }
    .firmElectBtn {
      position: absolute;
      bottom: 0;
      .btn {
        display: inline-block;
        width: 207px;
        height: 71px;
        border-radius: 3px;
        margin-right: 23px;
        img {
          width: 207px;
          height: 71px;
        }
      }
    }
  }
}
</style>
